export function addUtmQueryParams(url?: string, product?: string, area?: string) {
  if (!url) return ''

  try {
    const urlObj = new URL(url)
    urlObj.searchParams.set('utm_content', area ?? '')
    urlObj.searchParams.set('utm_medium', 'product')
    urlObj.searchParams.set('utm_source', product ?? '')
    return urlObj.toString()
  } catch {
    return url
  }
}
